import { useEffect } from "react";

const SelectPlace = ({ places, selectedPlace, setSelectedPlace, disabled = false }) => {
    useEffect(() =>{
        if (places.length > 0) {
            setSelectedPlace(places[0].name);
        }
    }, [places]);
    return (
        <select
        disabled={disabled}
        id='place-select'
        className='choice-select'
        value={selectedPlace}
        onChange={(e) => setSelectedPlace(e.target.value)}
        >
            {selectedPlace === '' ? <option value="">
                ------
            </option> : null}
            {places && places.map((place) => (
                <option
                    key={place.id}
                    value={place.name}
                >
                    {place.name}
                </option>
            ))}
        </select>
    );
};

export default SelectPlace;